(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clone-home-v3"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(e) {
  var next = e.target.closest('[data-cat-next]');
  var prev = e.target.closest('[data-cat-prev]');
  var id = next ? next.getAttribute('data-cat-next') : (prev ? prev.getAttribute('data-cat-prev') : null);
  if (!id) return;
  var scroller = document.getElementById('fh-cat-scroll-' + id);
  if (!scroller) return;
  var amount = scroller.clientWidth;
  scroller.scrollBy({ left: next ? amount : -amount, behavior: 'smooth' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
